import React from "react";

export default function AddressFields({
    prefix = "",                  // e.g., "partner_" or "facility_"
    formData = {},                // parent form data
    onChange = () => {},          // parent handleChange
    errors = {},                  // parent error object
    countries = [],               // dropdown options
    readOnly = false,             // disable in read-only mode
    requiredFields = [],          // ✅ new: required fields list from parent (e.g. ['address1', 'city'])
    includePostCode = false,
}) {
    const field = (name) => `${prefix}${name}`;

    const fields = [
        { label: "Address Line 1", name: "address1" },
        { label: "Address Line 2", name: "address2" },
        { label: "Pincode", name: "pincode" },
        ...(includePostCode ? [{ label: "Post Code", name: "postCode" }] : []),
        { label: "City", name: "city" },
        { label: "State", name: "state" },
        { label: "Country", name: "country", type: "select" },
    ];

    return (
        <div className="row gx-3 gy-3">
            {fields.map((f) => {
                const fieldName = field(f.name);
                const value = formData[fieldName] || "";
                const isRequired = requiredFields.includes(f.name); // ✅ dynamically decide required

                return (
                    <div className="col-md-3" key={fieldName}>
                        <label
                            htmlFor={fieldName}
                            className="form-label fw-semibold small mb-1"
                            style={{ cursor: "pointer" }}
                        >
                            {f.label}
                            {isRequired && <span className="text-danger">*</span>}
                        </label>

                        {f.type === "select" ? (
                            <select
                                className={`form-select form-select-sm ${
                                    errors[fieldName] ? "is-invalid" : ""
                                }`}
                                name={fieldName}
                                id={fieldName}
                                value={value}
                                onChange={onChange}
                                disabled={readOnly}
                            >
                                <option value="">Select Country</option>
                                {countries.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type={f.type || "text"}
                                className={`form-control form-control-sm ${
                                    errors[fieldName] ? "is-invalid" : ""
                                }`}
                                name={fieldName}
                                id={fieldName}
                                value={value}
                                onChange={onChange}
                                readOnly={readOnly}
                            />
                        )}

                        {errors[fieldName] && (
                            <div className="invalid-feedback d-block">
                                {errors[fieldName]}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
